export default __webpack_public_path__ + "static/media/cashew.13229de0.png";